import React, { useEffect, useState } from "react";
import { ShieldCheck, Plus, X } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export const TrustedSenders = () => {
  const [domains, setDomains] = useState([]);
  const [draft, setDraft] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/trusted-senders").then(({ data }) => setDomains(data.domains)).catch((e) => toast.error(formatError(e)));
  }, []);

  const save = async (next, msg) => {
    setBusy(true);
    try { const { data } = await api.put("/admin/trusted-senders", { domains: next }); setDomains(data.domains); setDraft(""); toast.success(msg); }
    catch (e) { toast.error(formatError(e)); } finally { setBusy(false); }
  };
  const add = (e) => {
    e.preventDefault();
    const d = draft.trim().toLowerCase().replace(/^.*@/, "");
    if (d) save([...domains, d], `${d} added`);
  };

  return (
    <div data-testid="trusted-senders-card" className="glass-card rounded-lg p-6">
      <div className="flex items-center gap-2 text-slate-200 font-display text-xl mb-2">
        <ShieldCheck size={18} className="text-emerald-400" /> Trusted Senders
      </div>
      <p className="text-sm text-slate-400 mb-4">
        Only pre-alerts from these email domains become shipments automatically. Others go to Skipped emails, where Admin can still make a shipment.
        {domains.length === 0 && <span className="text-amber-300"> The list is empty, so every sender is accepted.</span>}
      </p>
      <div data-testid="trusted-domains" className="flex flex-wrap gap-2 mb-4">
        {domains.map((d) => (
          <span key={d} className="inline-flex items-center gap-1.5 font-mono-ops text-xs px-2.5 py-1 rounded bg-emerald-500/10 text-emerald-200 border border-emerald-500/30">
            {d}
            <button data-testid={`remove-domain-${d}`} disabled={busy} title={`Remove ${d}`} className="text-emerald-300 hover:text-rose-300"
                    onClick={() => save(domains.filter((x) => x !== d), `${d} removed`)}><X size={12} /></button>
          </span>
        ))}
      </div>
      <form onSubmit={add} className="flex flex-col sm:flex-row gap-2 sm:max-w-md">
        <Input data-testid="input-trusted-domain" value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="e.g. kuehne-nagel.com"
               className="bg-slate-950 border-slate-700 font-mono-ops" />
        <Button data-testid="button-add-domain" type="submit" disabled={busy || !draft.trim()} className="bg-blue-600 hover:bg-blue-500">
          <Plus size={14} className="mr-1" /> Add domain
        </Button>
      </form>
    </div>
  );
};
